(function($){
  $(document).ready(function(){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {

    }else{
      $('.zoomple').zoomple({
        attachWindowToMouse: false
      });
    }
    $('.size-table').DataTable({
      "searching": false,
      "paging": false,
      "ordering": false,
      "responsive": true
    });
  });
})(jQuery);
